
import { Component, OnInit, ViewEncapsulation, OnDestroy, Input, ChangeDetectionStrategy, SimpleChanges, OnChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { TreeTable } from 'primeng/treetable';

@Component({
    selector: 'app-alm-break-down-ladder-table',
    templateUrl: './alm-break-down-ladder-table.component.html',
    styleUrls: ['./alm-break-down-ladder-table.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ALMBreakDownLadderTableComponent implements OnInit, OnDestroy, OnChanges {
    @Input()
    ladderTreeNodes: TreeNode[];
    @Input()
    ladderColumnNames: string[];
    @Input()
    showDelta = false;
    @Input()
    groupingColHeaderWidth = '25%';

    @Output()
    breakDownNodeSelected = new EventEmitter();

    @Output()
    breakDownNodeExpanded = new EventEmitter();

    @Output()
    breakDownNodeCollapsed = new EventEmitter();

    @ViewChild('treeTable', { static: false }) treeTable: TreeTable;

    onNodeSelect(event) {
        this.breakDownNodeSelected.emit(event);
    }

    onNodeExpand(event) {
        this.breakDownNodeExpanded.emit(event);
    }

    onNodeCollapse(event) {
        this.breakDownNodeCollapsed.emit(event);
    }

    expansionStates: { [key: string]: boolean } = {};

    selectedNode: any;
    initialized = false;

    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.initialized = false;
        this.initialized = true;
    }
    ngOnDestroy() {
    }

    storeExpansionState(nodes: TreeNode[], prefix: string) {
        if (nodes) {
            nodes
                .forEach((node) => {
                    const key = `${prefix}.${node.label}`;
                    this.expansionStates[key] = node.expanded;
                    this.storeExpansionState(node.children, key);
                });
        }
    }

    restoreExpansionState(nodes: TreeNode[], prefix: string) {
        if (nodes) {
            nodes
                .forEach((node) => {
                    const key = `${prefix}.${node.label}`;
                    node.expanded = this.expansionStates[key];
                });
        }
    }

    filterGlobal(value: string, matchMode: string) {
        if (this.treeTable) {
            // this.initialized = false;
            this.expansionStates = {};
            this.storeExpansionState(this.ladderTreeNodes, '');
            this.treeTable.filterGlobal(value, matchMode);
            this.restoreExpansionState(this.ladderTreeNodes, '');
            // setTimeout(() => {
            //     this.ladderTreeNodes = [...this.ladderTreeNodes];
            //     // this.restoreExpansionState(this.ladderTreeNodes, '');
            //     // this.initialized = true;
            // }, 50);
        }
    }


    primeNGFilterFix(event) {
        // Don't need to do anything, just needs a method to fire on callback
        // or else filtering doesnt work consistently
        // https://forum.primefaces.org/viewtopic.php?f=35&t=57732&p=172341&hilit=global+filter#p172341
    }

}
